export default {
   API_KEY: process.env.API_KEY,
   CLIENT_ID: process.env.CLIENT_ID,
}